import { createContext, type Dispatch, type RefObject } from 'react';
import type { ParamItemProps } from './ParameterItem';

export type ParamItemContext = Omit<ParamItemProps, 'pendoIds'> & {
  open: boolean;
  setOpen: Dispatch<React.SetStateAction<boolean>>;
  textInputRef: RefObject<HTMLElement>;
  toggleRef: RefObject<HTMLDivElement>;
};

export const ParameterItemContext = createContext<ParamItemContext | null>(null);
